import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "@/lib/utils";

/** Primer's Flash banner. */
const alertVariants = cva("mt-4 rounded-md border p-4", {
  variants: {
    variant: {
      info: "border-info-muted bg-info-subtle [&_[data-slot=alert-title]>svg]:text-info",
      error: "border-danger-muted bg-danger-subtle [&_[data-slot=alert-title]>svg]:text-danger",
      warning: "border-warning-muted bg-warning-subtle [&_[data-slot=alert-title]>svg]:text-warning",
      success: "border-success-muted bg-success-subtle [&_[data-slot=alert-title]>svg]:text-success",
    },
  },
  defaultVariants: { variant: "info" },
});

function Alert({ className, variant, ...props }: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
  return <div data-slot="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="alert-title" className={cn("mb-1 flex items-center gap-2 font-semibold [&>svg]:shrink-0", className)} {...props} />;
}

export { Alert, AlertTitle };
